import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DatePicker as BDatePicker, DatepickerProps } from "baseui/datepicker";
import { getLanguage } from "@helpers";
import { css } from "@emotion/react";
import theme from "@styles/theme";

interface DatePickerProps
  extends Pick<DatepickerProps, "onChange" | "disabled" | "minDate"> {
  date: Date;
  label?: string;
  required?: boolean;
}

const DatePicker: FC<DatePickerProps> = ({
  date,
  onChange,
  disabled,
  minDate,
  label,
  required = false,
}) => {
  const { t } = useTranslation();
  return (
    <div css={styles.wrapper}>
      {label && (
        <label
          css={[
            {
              marginBottom: "2px",
            },
          ]}>
          {label}
          {required && <span css={{ color: theme.colors.negative400 }}>*</span>}
        </label>
      )}
      <BDatePicker
        placeholder={t("common.selectDate")}
        clearable={false}
        formatString="d MMMM yyyy"
        locale={getLanguage()}
        value={[date]}
        onChange={onChange}
        disabled={disabled}
        minDate={minDate}
        overrides={{
          Input: {
            props: {
              overrides: {
                Input: {
                  style: { backgroundColor: "white" },
                },
              },
            },
          },
          Popover: {
            props: {
              overrides: {
                Body: {
                  style: {
                    zIndex: 999,
                    position: "absolute",
                    top: "20%",
                    left: "15%",
                  },
                },
              },
            },
          },
          Day: {
            style: ({ $disabled, $theme, $selected }) => ({
              backgroundColor: $theme.colors.white,
              color: $disabled
                ? $theme.colors.contentInverseSecondary
                : $theme.colors.contentPrimary,

              ":after": {
                backgroundColor: $selected
                  ? $theme.colors.primary
                  : $theme.colors.white,
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                borderLeftWidth: "1px",
                borderTopStyle: "solid",
                borderRightStyle: "solid",
                borderBottomStyle: "solid",
                borderLeftStyle: "solid",
                borderTopColor: $theme.colors.white,
                borderRightColor: $theme.colors.white,
                borderBottomColor: $theme.colors.white,
                borderLeftColor: $theme.colors.white,
              },
            }),
          },
          MonthYearSelectPopover: {
            props: {
              overrides: {
                Body: {
                  style: { zIndex: 1000 },
                },
              },
            },
          },
        }}
      />
    </div>
  );
};
const styles = {
  label: css({
    paddingBottom: "10px",
  }),
  wrapper: css({
    display: "flex",
    flexDirection: "column",
  }),
  helper: css({
    fontSize: ".8rem",
    color: theme.colors.mono600,
  }),
};
export default DatePicker;
